import Constant from '@/common/constant/Constant';
import { Button, Dialog, DialogActions, DialogContent } from '@material-ui/core';
import { I18n } from 'aws-amplify';
import { cloneDeep } from 'lodash';
import { onResendMessage } from '../handler/ChatPostHandler';

export const DialogSendChatPostFail = props => {

    const onHandlerCancel = () => {
        props.setIsOpenDialogSendChatPostFail(false);
        let chatPostAllListNew = cloneDeep(props.chatPostAllList);
        chatPostAllListNew = chatPostAllListNew.slice(0, -1);;
        props.setChatPostAllList({
            type: Constant.ACTION_CHANGE_LIST_DATA_TYPE.INITIAL,
            posts: chatPostAllListNew ? chatPostAllListNew : [],
        });
    };

    const onHandlerResendMessage = async () => {
        let chatPostInsertFail = props.chatPostInsertFail;
        let dataResend = chatPostInsertFail.data;
        delete dataResend.userDetailPostMsg;
        let inputChatPost = {
            createNewChatPostRequestDto : dataResend
        }
        props.setIsOpenDialogSendChatPostFail(false);
        await onResendMessage(props?.API, inputChatPost, props.userDetail, props.setChatPostUpdate, props.setChatPostInsertFail);
    };

    return (
        <Dialog
            open={props.isOpenDialogSendChatPostFail}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
            className="wrapDialog"
        >
            <DialogContent>
                <div className="confirmPlease">{I18n.get('COMMSG002')}</div>
            </DialogContent>
            <DialogActions className="confirm-dialog-action">
                <Button
                    onClick={onHandlerResendMessage}
                    variant="contained"
                    className="btn-hg32 btn-handle-delete-user-agree"
                >
                    {I18n.get('COMBTN006')}
                </Button>

                <Button
                    variant="contained"
                    className="btn-light btn-hg32"
                    onClick={onHandlerCancel}
                >
                    {I18n.get('COMBTN005')}
                </Button>
            </DialogActions>
        </Dialog>
    );
};
